import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import NumberFormat from 'react-number-format'
import moment from 'moment'

import './style.scss'

const Index = () => {

	const loading = useSelector(state => state.singleClient.fetchDetails.loading)
	const clientDetails = useSelector(state => state.singleClient.details)

	const renderData = data => {
		if(loading){
			return <i className="fas fa-circle-notch fa-spin"></i>
		} else if(!loading && Object.keys(clientDetails).length > 0){
			switch(data){
				case "organizationNumber":
					if(clientDetails.general && clientDetails.general.organizationNumber){
						return <NumberFormat format="### ### ###" displayType={'text'} value={clientDetails.general.organizationNumber}/>
					} else {
						return "Ikke tilgjengelig"
					}
				case "industry":
					if(clientDetails.general && clientDetails.general.industry){
						return clientDetails.general.industry
					} else {
						return "Ikke tilgjengelig"
					}
				case "parentCompany":
					if(clientDetails.general && clientDetails.general.parentCompany && clientDetails.general.parentCompany.name){
						return clientDetails.general.parentCompany.name
					} else {
						return "Ikke tilgjengelig"
					}
				case "established":
					if(clientDetails.general && clientDetails.general.established){
						return moment.unix(clientDetails.general.established).format('DD/MM/YYYY')
					} else {
						return "Ikke tilgjengelig"
					}
				case "employees":
					if(clientDetails.general && clientDetails.general.employees){
						return clientDetails.general.employees
					} else {
						return "Ikke tilgjengelig"
					}
				case "shareCapital":
					if(clientDetails.general && clientDetails.general.shareCapital){
						return <NumberFormat format="### ### ###" displayType={'text'} value={clientDetails.general.shareCapital} />
					} else {
						return "Ikke tilgjengelig"
					}
				case "creditRating":
					if(clientDetails.financials && clientDetails.financials.creditRating && clientDetails.financials.creditRating.rating){
						return clientDetails.financials.creditRating.description
					} else {
						return "Ikke tilgjengelig"
					}
				case "creditScore":
					if(clientDetails.financials && clientDetails.financials.creditRating && clientDetails.financials.creditRating.description){
						return clientDetails.financials.creditRating.rating
					} else {
						return "Ikke tilgjengelig"
					}
				default:
					return "Ikke tilgjengelig"
			}
		}
	}

	return(
		<div className="tab-pane all-details-tab fade show active" id="nav-details" role="tabpanel" aria-labelledby="nav-details-tab">
			<div className="tab-content-container">
				<div className="all-details-container">
					<Row className="company-upper-row">
						<Col className="content-col">
							<h3 className="section-title">Bedriftsinformasjon</h3>
							<p className="section-description">Nedenfor finner du informasjon relatert til bedriften som er hentet fra offentlige registre, eller som du har lagt inn selv. Du kan kontakte bedriften gjennom telefon, e-post, nettside og sosiale medier ovenfor.</p>
						</Col>
					</Row>
					<Row className="company-details-row">
                        <Col className="company-left-col">
                            <Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Organisasjonsnummer</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("organizationNumber")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Bransje</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("industry")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Morselskap</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("parentCompany")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row bottom">
                                <Col className="information-col text-left">
                                    <label className="label-title">Stiftet</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("established")}</label>
                                </Col>
                            </Row>
                        </Col>
                        <Col className="company-right-col">
                            <Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Antall ansatte</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("employees")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Aksjekapital</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("shareCapital")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row">
                                <Col className="information-col text-left">
                                    <label className="label-title">Kredittvurdering</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("creditScore")}</label>
                                </Col>
                            </Row>
							<Row className="single-information-row bottom">
                                <Col className="information-col text-left">
                                    <label className="label-title">Kredittverdighet</label>
                                </Col>
                                <Col className="information-col text-right">
                                    <label className="label-data">{renderData("creditRating")}</label>
                                </Col>
                            </Row>
                        </Col>
                    </Row>            
          
				</div>
			</div>
		</div>
	)
}

export default Index

